import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts'

import OverviewGraphTooltip from 'components/atoms/OverviewGraphTooltip'
import OverviewGraphActiveDot from 'components/atoms/OverviewGraphActiveDot'

import { formatDate, LOCAL_DATE_FORMAT_MONTH_YEAR } from 'utils/date'

const styles = theme => ({
  root: {
    position: 'relative',
    animation: 'fadeIn .2s ease',
  },
  axisLabels: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    justifyContent: 'space-between',
    color: theme.palette.disabled.main,
    padding: `0 ${theme.spacing(1)}px 0 ${theme.spacing(4)}px`,
  },
})

const TooltipPlaceholder = () => <div />

const xAxisLine = { stroke: '#ddd', strokeDasharray: '3 3' }
const tick = { fill: '#aaa', fontSize: 14 }

class OverviewGraph extends React.Component {
  state = {
    tooltipX: 0,
    tooltipY: 0,
    flipped: false,
    tooltipData: null,
  }

  onActiveDotChange = (props) => {
    this.setState({
      showTooltip: true,
      tooltipX: props.cx,
      flipped: props.cx > 600, // Flips the tooltip card to stay in field of view + switch arrow position
      tooltipY: props.cy - 40,
      tooltipData: props.payload,
    })
  }

  onMouseLeave = () => {
    this.setState({ showTooltip: false, tooltipX: 0 })
  }

  formatDate = (value) => {
    return formatDate(value, LOCAL_DATE_FORMAT_MONTH_YEAR)
  }

  formatYAxis = (value) => {
    return value > 0 ? value : ''
  }

  render() {
    const {
      tooltipX,
      tooltipY,
      tooltipData,
      showTooltip,
      flipped,
    } = this.state
    const { classes, className, data } = this.props

    const axisProps = {
      axisLine: false,
      tickLine: false,
      tick,
    }

    return (
      <div className={classNames(classes.root, className)}>
        <div className={classes.axisLabels}>
          <Typography>Kills</Typography>
          <Typography>Percentage of traps</Typography>
        </div>
        <ResponsiveContainer width="100%" height="100%" aspect={4.0 / 1.25}>
          <LineChart
            data={data}
            onMouseLeave={this.onMouseLeave}
            onBlur={this.onMouseOut}>
            <YAxis
              yAxisId="left"
              dataKey="totalKills"
              tickFormatter={this.formatYAxis}
              {...axisProps}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tickFormatter={this.formatYAxis}
              dataKey="percentageTrapsSynced"
              domain={[0, 100]}
              {...axisProps}
            />
            <XAxis
              dataKey="date"
              tickMargin={5}
              minTickGap={100}
              tickFormatter={this.formatDate}
              padding={{ left: 20, right: 20 }}
              {...axisProps}
              axisLine={xAxisLine}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="totalKills"
              strokeWidth="3"
              stroke="#419EF6"
              dot={false}
              activeDot={
                <OverviewGraphActiveDot
                  open={showTooltip}
                  tooltipX={tooltipX}
                  onChange={this.onActiveDotChange}
                />
              }
            />
            <Line
              dot={false}
              type="linear"
              yAxisId="right"
              dataKey="percentageTrapsSynced"
              stroke="#419EF6"
              strokeDasharray="3 5"
            />
            <Tooltip
              offset={0}
              isAnimationActive={false}
              content={TooltipPlaceholder}
              viewBox={{
                x: 0,
                y: 0,
                width: 400,
                height: 400,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
        <OverviewGraphTooltip
          x={tooltipX}
          y={tooltipY}
          flipped={flipped}
          data={tooltipData}
          open={showTooltip}
        />
      </div>
    )
  }
}

OverviewGraph.propTypes = {
  data: PropTypes.array,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(OverviewGraph)



// WEBPACK FOOTER //
// ./src/components/organisms/Overview/Graph.js